import React, { useEffect } from 'react'
import AOS from 'aos'
import Navbar from './navbar'

const Header = () => {
  useEffect(() => {
    AOS.init({ once: true })
  }, [])

  return (
    <div className='relative bg-white'>
      <div className='max-w-7xl mx-auto'>
        <Navbar />

        <main className='mx-auto max-w-7xl mb-8 sm:mb-12 md:mb-16'>
          <div className='flex items-center flex-wrap'>
            <div className='w-full sm:w-1/2 text-left py-8 sm:py-12 md:py-16 lg:py-20 xl:pb-28 px-4 md:px-6 lg:px-8'>
              <h1
                className='text-3xl md:text-5xl lg:text-6xl tracking-tight font-extrabold text-gray-900'
                data-aos='flip-up'
                data-aos-duration='1500'
                data-aos-delay='500'
              >
                <span className='block xl:inline'>Contribute to your safe</span>{' '}
                <span className='block text-oya-ghana-green xl:inline'>
                  travel experience!
                </span>
              </h1>

              <p className='py-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0 leading-relaxed'>
                Enjoy an experience of safe travel with the Oya! App - flexible routes, lower fares and
                more incredible experience. Travelling between cities should be simple and adaptable
                with increased mobility and accessibility as the transportation infrastructure expands,
                and Oya Ghana makes this possible in real-time. Passengers receive cutting-edge,
                innovative, and sustainable modes of transportation.
              </p>

              <div className='py-6 sm:py-8'>
                <a
                  href='/'
                  className='px-6 py-3 text-base font-medium text-white bg-oya-ghana-green hover:bg-green-500 md:py-4 md:text-lg md:px-10 rounded-md shadow'
                >
                  Get Started
                </a>
              </div>
            </div>
            <div className="w-full sm:h-screen sm:w-1/2 px-4 sm:px-6 md:px-8 lg:px-16">
              <div className="w-full sm:min-h-[33.33%]">
                <div className="relative w-1/2 lg:w-5/12">
                  <img
                    className='w-full h-full object-cover rounded-full'
                    src='/assets/images/landing/illu1.png'
                    data-aos='fade-right'
                    data-aos-duration='1500'
                    alt='oyaparcel'
                  />
                  <img
                    className='absolute bottom-0'
                    style={{ right: '-65%' }}
                    src='/assets/images/landing/mov-1.png'
                    data-aos='fade-down-right'
                    data-aos-duration='1500'
                    alt='oyaparcel'
                  />
                </div>
              </div>

              <div className="relative sm:min-h-[33.33%] flex justify-end">
                <img
                  className='w-1/2 lg:w-5/12 h-full object-cover rounded-full'
                  src='/assets/images/landing/illu2.png'
                  data-aos='fade-down'
                  data-aos-duration='1500'
                  alt='oyabus'
                />
              </div>

              <div className="w-full relative sm:min-h-[33.33%]">
                <div className="relative w-1/2 lg:w-5/12">
                  <img
                    className='absolute top-0 mt-6 sm:mt-0 md:pt-4'
                    style={{ right: '-50%' }}
                    src='/assets/images/landing/mov-2.png'
                    data-aos='fade-down-left'
                    data-aos-duration='1500'
                    alt='oyaparcel'
                  />
                  <img
                    className='w-full h-full object-cover rounded-full'
                    src='/assets/images/landing/illu3.png'
                    data-aos='fade-left'
                    data-aos-duration='1500'
                    alt='oyadispatch'
                  />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export default Header
